// extracted by mini-css-extract-plugin
export default {"text":"styles_text__EDVvU","header":"styles_header__jbP-G","name":"styles_name__V5BJ4"};